<template>
    <div class="base">
        <div class="course-header">
            <div class="course-content">
                <div class="qtz-course"><img src="../../assets/imgs/course/base-title-icon.png" alt="">基础能力课</div>
                <ul class="course-detail">
                    <li>以脑力开发为特色，结合0-6岁孩子大脑发育的特点，</li>
                    <li>每节课平均18个环节、30余种教具，</li>
                    <li>全面锻炼、提升孩子大脑的五大基础认知能力。</li>
                </ul>
            </div>
        </div>

        <div class="course-content" style="margin-top: 50px;">
            <img src="../../assets/imgs/course/course-type-12-16-3.png" alt="">
        </div>

        <div class="course-content max-title">
            <span>特色环节</span>
            <span>Characteristic games</span>
        </div>
        <div class="section-content feature">
            <ul>
                <li v-for="(item,index) in featureList" :key="item.title">
                    <div class="feature-title">{{item.title}}</div>
                    <div class="feature-detail" v-if="index!=5&&index!=6">{{item.content}}</div>
                    <div v-if="index==5">
                        <img style="margin: 0 auto;display: block" src="../../assets/imgs/course/base-1.png" alt="">
                    </div>
                    <div v-if="index==6">
                        <img style="margin: 0 auto;display: block" src="../../assets/imgs/course/base-2.png" alt="">
                    </div>
                </li>
            </ul>
        </div>
        <div class="base-bottom">
            <div class="course-content" style="position: relative">
                <div class="content-item">
                    <div class="content-title">
                        <button class="page-btn">闪卡</button>
                    </div>
                </div>
            </div>

            <div class="course-content">
                <div class="shanka">
                    <span>12000+</span> 张闪卡
                    <span style="margin-left: 20px;">300+</span> 种类
                </div>

                <ul class="shanka-detail">
                    <li>建立类别概念,培养超出同龄孩子数倍的词汇量;</li>
                    <li>系统的闪卡教学法,科学设计闪示速度和频率,培养记忆力和反应力。</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "base",
        data(){
            return {
                featureList: [
                    {
                        title: '呼吸想象',
                        content: '首先通过调整呼吸，引导有意识的拉长呼吸，增强注意力，培养自控力。而后进入符合宝宝心理发展特征的主题想象，引导充分发挥想象力。'
                    },
                    {
                        title: '一体感游戏',
                        content: '增强师生间的信任感和一体感，加强亲子一体感，培养宝宝的安全感和自信心，在轻松愉快中建立有利于学习的课堂氛围。'
                    },
                    {
                        title: '眼肌训练',
                        content: '活化宝宝眼部肌肉，扩大视野幅度，加强眼部追踪能力，强化注意力。'
                    },
                    {
                        title: '记忆法',
                        content: '有趣的记忆游戏，在游戏中帮助宝宝增强记忆容量，加强记忆速度，引导逐步形成记忆策略。'
                    },
                    {
                        title: '速听速度',
                        content: '运用高速的音频，训练宝贝的听力，在游戏中引导宝贝提高注意力、增强反应力。'
                    },
                    {
                        title: '诵读',
                        content: '首先通过调整呼吸，引导有意识的拉长呼吸，增强注意力，培养自控力。而后进入符合宝宝心理发展特征的主题想象，引导充分发挥想象力。'
                    },
                    {
                        title: '迷宫',
                        content: '首先通过调整呼吸，引导有意识的拉长呼吸，增强注意力，培养自控力。而后进入符合宝宝心理发展特征的主题想象，引导充分发挥想象力。'
                    },
                    {
                        title: '智能',
                        content: '引导孩子掌握各种基础概念，而后综合利用理解、推理、想象等多种思维能力进行有趣的游戏，全方位提升思维的灵活性、深刻性、独创性。'
                    },
                    {
                        title: '语言',
                        content: '进行趣味文字练习，培养孩子的阅读习惯，逐步增强阅读语言表达、书面作文能力，同时利用孩子喜欢模仿的年龄特性，引导他们养成良好的生活习惯。'
                    },
                    {
                        title: '数学',
                        content: '遵循儿童发展科学规律，运用七田真特色教具，进行数量与数字的游戏练习，培养数学思维和基础计算能力，为未来学习打下基础。'
                    },
                ]
            }
        }
    }
</script>

<style scoped lang="less">
    .base{
        .course-header{
            background-image: url("../../assets/imgs/course/base-bg.png");
        }
        .feature{
            margin-top: 40px;
            ul{
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                li{
                    width: 200px;
                    margin-bottom: 40px;
                    .feature-title{
                        margin-bottom: 25px;
                        font-weight: 600;
                        font-size: 18px;
                        color: #fff;
                        height: 60px;
                        line-height: 60px;
                        background: #D3534E;
                        text-align: center;
                    }
                    .feature-detail{
                        font-family:Light;
                        font-size: 16px;
                        color: #767473;
                    }
                }
            }
        }
        .base-bottom{
            width: 100%;
            height: 800px;
            padding-top: 50px;
            position: relative;
            background: url("../../assets/imgs/course/base-bottom-bg.png") no-repeat;
            background-size: cover;
        }
        .content-item{
            margin-bottom: 20px;
            border-top: 1px solid #F19EB4;
            .page-btn{
                width: 150px;
                height: 40px;
                font-weight: 600;
                font-size: 20px;
                background: #D3534E;
                color: #fff;
                border-bottom-left-radius: 10px;
                border-bottom-right-radius: 10px;
                border: none;
                outline: none;
            }
        }
        .max-title{
            display: flex;
            align-items: center;
            justify-content: space-between;
            color: #D3534E;
            margin-bottom: 15px;
            margin-top: 50px;
            padding-bottom: 10px;
            border-bottom: 1px solid #D3534E;
            span:first-child{
                font-weight: 600;
                font-size: 35px;
            }
            span:last-child{
                font-size: 20px;
            }
        }
        .shanka{
            margin-top: 40px;
            margin-bottom: 50px;
            font-size: 30px;
            color: #5C5959;
            span{
                margin-top: 40px;
                font-weight: 600;
                font-size: 40px;
                color: #D3534E;
            }
        }
        .shanka-detail{
            font-size: 18px;
            font-weight: normal;
            color: #7F7A7A;
            line-height: 1.8;
        }
    }
</style>
